import { UPDATE_EVENTS } from "Redux/Actions/eventsActions";

const INITIAL_STATE = {
  // motsClés: "",
  // category: [],
  // date: "",
  // eventsData: [],
  categoriesData: [],
  // eventsFiltered: [],
  // isSearchedEvent: false,
  etats: [],
  randomEvent: [],
  participants: [],
  eventParticipants: [],
  myEvents: [],
  dataFromPagination: {
    data: [],
    loaded: false,
    page: 1,
    totalItems: 0,
  },
};

const eventsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_EVENTS: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default eventsReducer;
